import './_header.scss';
import {useContext, useEffect, useMemo} from "react";
import {LayoutContext} from "../../components/layout-context-container";
import {Link} from "react-router-dom";
import headerLogo from "./images/what-the-cah-logo.png";
import HcpHeaderNav from "./components/header-nav";

function HcpHeader() {
  const {showMobileMenu, setShowMobileMenu} = useContext(LayoutContext);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth >= 1024) {
        // auto close mobile menu if opened from desktop and screen becomes larger than tablet size
        setShowMobileMenu(false);
      }
    }

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [setShowMobileMenu]);

  useEffect(() => {
    // disable page scroll if mobile menu is open
    if (showMobileMenu) {
      // open
      document.body.style.position = "sticky";
      document.body.style.height = "100%";
      document.body.style.overflow = "hidden";
    } else {
      // close
      document.body.style.position = "";
      document.body.style.height = "";
      document.body.style.overflow = "";
    }

  }, [showMobileMenu]);

  const containerClass = useMemo(() => {
    var className = 'hcp-header';

    if (showMobileMenu) {
      className = `${className} hcp-header--mobile-menu-showing`;
    }

    return className;
  }, [showMobileMenu]);

  const mobileNavWrapperClass = useMemo(() => {
    var className = 'hcp-header__mobile-nav-wrapper';

    if (showMobileMenu) {
      className = `${className} hcp-header__mobile-nav-wrapper--mobile-menu-showing`;
    }

    return className;
  }, [showMobileMenu])
  return (
    <>
      <header className={containerClass}>
        <div className="container--desktop-small container--padding-x2">
          <div className="hcp-header__nav-wrapper">
            <div className='hcp-header__logo'>
              <Link
                to="/hcp"
                data-gtm-event-name="Header"
                data-gtm-event-category="Navigation"
                data-gtm-event-action="Click"
                data-gtm-event-label="WhatTheCAH Logo"
                onClick={() => setShowMobileMenu(false)}
              >
                <img
                  loading="eager"
                  // @ts-ignore
                  fetchpriority="high"
                  src={headerLogo}
                  width={123}
                  height={59}
                  alt="What the CAH logo"
                />
              </Link>
            </div>
            <HcpHeaderNav />
          </div>
        </div>
      </header>
      <div className="hcp-header__mobile-nav-wrapper-constrain">
        <div className={mobileNavWrapperClass}>
          <HcpHeaderNav customClass="container--desktop-small container--padding-x2" mobile />
          <br /><br /><br />
        </div>
      </div>
    </>
  );
}

export default HcpHeader;